import script from "./Shadow.vue?vue&type=script&setup=true&lang=ts"
export * from "./Shadow.vue?vue&type=script&setup=true&lang=ts"

import "./Shadow.scss?vue&type=style&index=0&id=32850412&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32850412"]])

export default __exports__